/* src/app/modules/employees/lista/employee-multi-select.component.scss */
.employee-multi-select-card {
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.employee-multi-select-card .mat-mdc-card-header {
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 0;
}
.employee-multi-select-card .mat-mdc-card-title {
  font-size: 1.2rem;
  font-weight: 600;
}
.employee-multi-select-card .mat-mdc-card-subtitle {
  font-size: 0.95rem;
  color: #666;
  margin-top: 4px;
}
.employee-multi-select-card .search-actions-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 12px;
}
.employee-multi-select-card .search-actions-row .search-field {
  flex: 2 1 200px;
  margin-right: 16px;
  min-width: 180px;
}
.employee-multi-select-card .search-actions-row .actions {
  flex: 1 1 120px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.employee-multi-select-card .empleados-lista {
  max-height: 260px;
  overflow-y: auto;
  margin-bottom: 8px;
}
.employee-multi-select-card .empleados-lista .empleado-item {
  padding: 4px 0;
}
.employee-multi-select-card .paginator-row {
  display: flex;
  justify-content: center;
  padding-top: 8px;
}
/*# sourceMappingURL=employee-multi-select.component.css.map */
